import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@material-ui/core';
import { IList } from 'annotation-tools/utils';
import React, { FC, memo } from 'react';
import styled from 'styled-components';
import { viewTexts } from '../../constants/view-texts';
import { IProjectSummaryType } from '../../types/record/project-summary';
import { MuiPaper } from './mui/mui-paper';
import { MuiTableRow } from './mui/mui-table-row';

const vt = viewTexts.labelCountResult;

const TableListWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
`;

const TableWrapper = styled.div`
  padding: 10px;
`;

const ModelNameWrapper = styled.div`
  padding: 5px;
  min-height: 35px;
`;

interface Props {
  projectSummary: IList<IProjectSummaryType>;
}

export const CountResult: FC<Props> = memo(
  ({ projectSummary }: Readonly<Props>) => (
    <TableListWrapper>
      {projectSummary.map((summary, idx) => (
        <TableWrapper key={idx}>
          <ModelNameWrapper>{summary.model.name}</ModelNameWrapper>
          <MuiPaper elevation={1}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align='left'>{vt.name}</TableCell>
                  <TableCell align='right'>{vt.count}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {summary.labels.map((label, idx) => (
                  <MuiTableRow key={idx} hover={false}>
                    <TableCell align='left'>{label.name}</TableCell>
                    <TableCell align='right'>{label.count}</TableCell>
                  </MuiTableRow>
                ))}
              </TableBody>
            </Table>
          </MuiPaper>
        </TableWrapper>
      ))}
    </TableListWrapper>
  )
);

CountResult.displayName = 'CountResult';
